import { useState } from 'react';

import { cn } from '@rocco/utils/cn';
import { INTRO_RAIL_BUTTON } from '~/ui-rocco/pages/directory-browse/DirectoryIntro';
import { SubscribePublicationsModal } from '@modules-rocco/subscription/component/SubscribePublicationsModal';

/** The rail's ink, the same as the prompt it stands in for. */
const RAIL_INK = 'bg-[#323232] text-white';

/**
 * What stands beside the editorial statement where the other directories
 * offer Get Matched: the publications. A reader of the articles is not
 * looking for a supplier, and the one thing this library has to offer them
 * is more of itself, weekly.
 *
 * The labelled button alone, on the prompt's own geometry, so the opening is
 * the category pages' opening with a different offer in the same place. The
 * caption and the plus the other directories set beside it are left off: the
 * publications' covers sit directly under this line and say what is on offer.
 */
export const EditorialSubscribeRail = () => {
    const [open, setOpen] = useState(false);
    // The modal is mounted once it is first wanted and stays mounted, so
    // closing keeps its animation. Hovering the button mounts it early,
    // which starts its catalogue fetch before the click.
    const [mounted, setMounted] = useState(false);
    const openModal = () => {
        setMounted(true);
        setOpen(true);
    };
    const prefetch = () => setMounted(true);

    return (
        <>
            <button
                type="button"
                onClick={openModal}
                onPointerEnter={prefetch}
                onFocus={prefetch}
                className={cn(INTRO_RAIL_BUTTON, RAIL_INK)}
            >
                Subscribe
            </button>
            {mounted ? (
                <SubscribePublicationsModal
                    open={open}
                    onClose={() => setOpen(false)}
                />
            ) : null}
        </>
    );
};
